import React, {useEffect, useState, useRef} from 'react';
import $api from "../http";
import "../css/card-creator.css"
import ModalDialog from "./ModalDialog";
import CardViewerTable from "./helpers/CardViewerTable";
import CardViewerTabs from "./helpers/CardViewerTabs";
import Select from "react-select";

const CardViewer = ({store, traders, updatedDevice, freshCard, completedOrder, updatedCards, isMobile}) => {



    const [activeModalInfo, setActiveModalInfo] = useState("no")
    const [activeModalConfirm, setActiveModalConfirm] = useState("no")
    const [activeModalQr, setActiveModalQr] = useState("no")
    const [qrData, setQrData] = useState("")
    const [qrName, setQrName] = useState("")

    const [activeModal, setActiveModal] = useState("no")
    const [modalMessage, setModalMessage] = useState("")

    const [processing, setProcessing] = useState({status: false, index: null})

    const [cardToDelete, setCardToDelete] = useState()
    const [cardToUnbind, setCardToUnbind] = useState()


    const [filter, setFilter] = useState({onlyActive: true})
    const [sortingFilter, setSortingFilter] = useState(() => {
        const saved = localStorage.getItem(store.user.roles.includes('trader') ? "mySortingFilter(trader)" : "mySortingFilter(support)");
        return saved ? JSON.parse(saved) : {onlineFirst: false};
    });


    useEffect(() => {
        if (qrData) {
            setActiveModalQr("progress")
            setTimeout(() => {
                setActiveModalQr("active")
            }, 100)
        }
    }, [qrData]);

    const startCardTest = async (cardId) => {
        console.log(cardId)

        const response = await $api.get(`/card_test?cardId=${cardId}`)

        console.log(response.data)

        // Получаем обновленный объект карты из ответа
        const updatedCard = response.data;

        // Обновляем состояние карт
        setCards(prevCards =>
            prevCards.map(card =>
                card._id === updatedCard._id ? updatedCard : card
            )
        );

    }




    const getCards = async (filter) => {


        console.log(filter)

        if(!filter?.onlyActive && !filter?.traderId && store.user.roles.includes('support')) {
            console.log('SETTING EMPTY ARRAY')
            setCards([])
            return
        }


        filter = filter ? encodeURIComponent(JSON.stringify(filter)) : ""

        const response = await $api.get(`/get_cards?filter=${filter}`)
        console.log(response.data)
        setCards(response.data)
    }

    const deleteCard = async (cardId) => {


        try {
            const response = await $api.delete(`/delete_card?cardId=${cardId}`)
            console.log(response.data)
            if(response.data === "OK") {

                setModalMessage(`Карта удалена!`)
                setActiveModalInfo("progress")
                setTimeout(() => {
                    setActiveModal("active")
                }, 100)

                setCards(prev => {
                    const newCardsState = prev.filter(card => card._id !== cardId)
                    return newCardsState
                })
            } else {
                setModalMessage(`Это не ваша карта, удалить ее нельзя!`)
                setActiveModalInfo("progress")
                setTimeout(() => {
                    setActiveModal("active")
                }, 100)
            }
        } catch (e) {
            setModalMessage(e.message)
            setActiveModalInfo("progress")
            setTimeout(() => {
                setActiveModal("active")
            }, 100)
        }



    }




    const unbindCard = async (cardId) => {


        try {
            const response = await $api.delete(`/unbind_card?cardId=${cardId}`)
            console.log(response.data)
            if(response.data._id) {

                setModalMessage(`Карта отвязана от устройства!`)
                setActiveModalInfo("progress")
                setTimeout(() => {
                    setActiveModal("active")
                }, 100)

                setCards(prev => {
                    const newCardsState = prev.map(card => card._id !== cardId ? card : response.data)
                    return newCardsState
                })
            } else {
                setModalMessage(`Это не ваша карта, отвязать ее нельзя!`)
                setActiveModalInfo("progress")
                setTimeout(() => {
                    setActiveModal("active")
                }, 100)
            }
        } catch (e) {
            setModalMessage(e.message)
            setActiveModalInfo("progress")
            setTimeout(() => {
                setActiveModal("active")
            }, 100)
        }



    }


    const activateCardWithoutTest = async (cardId, index) => {




        try {
            setProcessing({status: true, index})



            const response = await $api.get(`/activate_card_without_test?cardId=${cardId}`)
            console.log(response.data)


            // Получаем обновленный объект карты из ответа
            const updatedCard = response.data;

            // Обновляем состояние карт
            setCards(prevCards =>
                prevCards.map(card =>
                    card._id === updatedCard._id ? updatedCard : card
                )
            );
            setProcessing({status: false, index})

        } catch (e) {
            setModalMessage("Ошибка смены статуса карты\n" + e.message + "\n зовите админа")
            setActiveModal("progress")
            setTimeout(() => {
                setActiveModal("active")
            }, 100)
            setProcessing({status: false, index})
        }


    }



    const changeCardStatus = async (cardId, index) => {




        try {
            setProcessing({status: true, index})



            const response = await $api.get(`/change_card_status?cardId=${cardId}`)
            console.log(response.data)


            // Получаем обновленный объект карты из ответа
            const updatedCard = response.data;

            // Обновляем состояние карт
            setCards(prevCards =>
                prevCards.map(card =>
                    card._id === updatedCard._id ? updatedCard : card
                )
            );
            setProcessing({status: false, index})

        } catch (e) {
            setModalMessage("Ошибка смены статуса карты\n" + e.message + "\n зовите админа")
            setActiveModal("progress")
            setTimeout(() => {
                setActiveModal("active")
            }, 100)
            setProcessing({status: false, index})
        }


    }



    const [cards, setCards] = useState([])


    const [cardsToDisplay, setCardsToDisplay] = useState([])


    useEffect(() => {

        setCardsToDisplay(cards)


    }, [cards])



    useEffect(() => {
        store.setPageTitle("Все карты")

        if(store.user.roles.includes("support") && Object.keys(filter).length) {

            getCards(filter)
        } else {
            getCards()
        }

    }, [filter]);


    useEffect(() => {


        if(freshCard && Object.keys(freshCard).length) {

            // Обновляем состояние карт
            setCards(prevCards =>
                prevCards.map(card =>
                    card._id === freshCard._id ? freshCard : card
                )
            );
        }


    }, [freshCard])


    useEffect(() => {

        if(completedOrder && Object.keys(completedOrder).length && completedOrder.status === "completed") {
            const { card, amount } = completedOrder;
            const cardId = card._id;

            // Используем setCards, чтобы обновить состояние
            setCards(prevCards => {
                return prevCards.map(c => {
                    // Если ID карты совпадает, обновляем reminderOfLimit
                    if (c._id === cardId) {
                        return {
                            ...c,
                            reminderOfLimit: c.reminderOfLimit - amount, // Отнимаем amount
                        };
                    }
                    return c; // Оставляем карту без изменений
                });
            });
        }

    }, [completedOrder])


    useEffect(() => {

        console.log(updatedDevice)
        if(store.user.roles.includes("support") && updatedDevice && Object.keys(updatedDevice).length) {

            console.log("THIIS IS SUPPORT EFFECT")

            if((updatedDevice?.user === filter.traderId || updatedDevice?.user?._id === filter.traderId || updatedDevice?.isCard) && !filter.onlyActive) {


                console.log("SUPPORT TRY TO SETTING CARDS")

                setCards(prev => {
                    const newCardsState = prev?.map(card => {
                        // console.log(card)
                        if(card.device?._id === updatedDevice?._id) {
                            card.device.online = updatedDevice.online
                            // card.device.workStatus = updatedDevice.workStatus
                        } else if (card._id === updatedDevice?.card?._id) {

                            card.device = updatedDevice

                        } else if(card._id === updatedDevice?._id) {

                            console.log("RETURNING UPDATED DEVICE")
                            return updatedDevice
                        }

                        return card

                    })

                    return newCardsState
                })

            } else if(filter.onlyActive) {

                const userFilter = filter.traderId
                    ?
                    updatedDevice.isCard
                        ?
                        updatedDevice.user === filter.traderId
                        :
                        updatedDevice.card?.user === filter.traderId
                    :
                    true

                const cardActivity = updatedDevice.isCard
                    ?
                    updatedDevice.active
                    && !updatedDevice.stopByFails
                    && !updatedDevice.stopByAdmin
                    && (updatedDevice.isOnline || (updatedDevice.webHook && updatedDevice.webHookTestPassed))
                    :
                    updatedDevice.card?.active
                    && (updatedDevice.online || (updatedDevice.card.webHook && updatedDevice.card.webHookTestPassed))
                    && !updatedDevice.card.stopByFails
                    && !updatedDevice.card.stopByAdmin
                    && userFilter


                // console.log(updatedDevice.card.user)
                // console.log(filter.traderId)
                //
                // console.log(updatedDevice.card.active)
                // console.log((updatedDevice.online || (updatedDevice.card.webHook && updatedDevice.card.webHookTestPassed)))
                // console.log(!updatedDevice.card.stopByFails)
                // console.log(!updatedDevice.card.stopByAdmin)
                // console.log(userFilter)

                console.log("CARD ACTIVITY IS", cardActivity)

                if(cards.some(card => card._id === updatedDevice.card?._id || card._id === updatedDevice._id) && !cardActivity) {

                    if(updatedDevice.card?._id) {
                        setCards(prev => prev.filter(card => card._id !== updatedDevice.card._id))
                    } else {
                        setCards(prev => prev.filter(card => card._id !== updatedDevice._id))
                    }



                    // setCards(prev => {
                    //     const newCardsState = prev?.map(card => {
                    //
                    //         if(card.device?._id === updatedDevice?._id) {
                    //             card.device.online = updatedDevice.online
                    //
                    //         } else if (card._id === updatedDevice?.card?._id) {
                    //
                    //             card.device = updatedDevice
                    //
                    //         } else if(card._id === updatedDevice?._id) {
                    //
                    //             console.log("RETURNING UPDATED DEVICE")
                    //             return updatedDevice
                    //         }
                    //
                    //         return card
                    //
                    //     })
                    //
                    //     return newCardsState
                    // })

                } else  {

                    if(cardActivity) {

                        if(updatedDevice.isCard) {

                            const freshCardObject = {...updatedDevice}

                            // freshCardObject.isOnline = updatedDevice.online
                            // freshCardObject.device = {_id: freshCardObject.device, online: true}
                            // freshCardObject.user = updatedDevice.user

                            console.log(freshCardObject)

                            setCards(prev => [freshCardObject, ...prev])

                        } else {

                            const freshCardObject = {...updatedDevice.card}

                            freshCardObject.isOnline = updatedDevice.online
                            freshCardObject.device = {_id: freshCardObject.device, online: true}
                            freshCardObject.user = updatedDevice.user

                            console.log(freshCardObject)

                            setCards(prev => [freshCardObject, ...prev])

                        }

                    }

                }

            } else {
                console.log("ТУТ ЧЕГО ТО НЕТ")
            }

        }

        if(store.user.roles.includes("trader")) {

            setCards(prev => {

                const newCardsState = prev?.map(card => {
                    // console.log(card)
                    //этот блок
                    if(card.device?._id === updatedDevice?._id || card.device?._id === updatedDevice?.card?._id) {

                        if(card.device) {
                            card.device.online = updatedDevice.online
                            card.isOnline = updatedDevice.online
                        }

                        //этот блок работает когда нужно обновить стейт вновь привязываемого устройства к карте
                    } else if (card._id === updatedDevice?.card?._id) {

                        card.device = updatedDevice

                    } else if(card._id === updatedDevice?._id) {
                        return updatedDevice
                    }

                            return card

                        })

                        return newCardsState
                    })
                }



            }, [updatedDevice, filter, store.user])


            useEffect(() => {

                if(updatedCards?.length) {
                    setCards(prevCards => {
                        // Обновляем существующие объекты
                        const updatedExisting = prevCards.map(card => {
                            const found = updatedCards.find(newCard => newCard._id === card._id);
                            return found ? found : card;
                        });
                        // Находим новые объекты, которых нет в предыдущем состоянии
                        const newCards = updatedCards.filter(newCard =>
                            !prevCards.some(card => card._id === newCard._id)
                        );
                        // Объединяем обновлённые существующие и новые объекты
                        return [...updatedExisting, ...newCards];
                    });
                }



            }, [updatedCards]);


    const [sortedCards, setSortedCards] = useState([])


    useEffect(() => {
        // Сохраняем настройки в localStorage
        localStorage.setItem("mySortingFilter(trader)", JSON.stringify(sortingFilter));

        if (cards.length) {
            // 1. Делаем копию массива
            // let sortedCardsState = [...cards];

            let sortedCardsState = [];
            const seenIds = new Set();
            for (const card of cards) {
                if (!seenIds.has(card._id)) {
                    sortedCardsState.push(card);
                    seenIds.add(card._id);
                }
            }

            // 2. Сортируем согласно sortingFilter.sort
            if (sortingFilter.sort === "alphabet") {
                sortedCardsState.sort((a, b) => a.cardholder.localeCompare(b.cardholder));
            } else if (sortingFilter.sort === "alphabet-reverse") {
                sortedCardsState.sort((a, b) => b.cardholder.localeCompare(a.cardholder));
            } else if (sortingFilter.sort === "bank") {
                sortedCardsState.sort((a, b) => a.bank.localeCompare(b.bank));
            } else if (sortingFilter.sort === "date-reverse") {
                sortedCardsState.reverse();
            }

            // 3. Если нужно «онлайн-сначала» — группируем
            //    (все, у кого isOnline === true, пойдут первыми,
            //     при этом внутренний порядок не меняется).
            if (sortingFilter.onlineFirst) {
                const onlineCards = sortedCardsState.filter(card => card.isOnline);
                const offlineCards = sortedCardsState.filter(card => !card.isOnline);
                sortedCardsState = [...onlineCards, ...offlineCards];
            }

            // 4. Сохраняем результат
            setSortedCards(sortedCardsState);
        } else {
            setSortedCards([])
        }
    }, [cards, sortingFilter]);




            return (
                <div className={"card-viewer-wrapper"}>

                    {store.user.roles.includes("trader")
                        ?
                        <div className={`order-filter-wrapper ${isMobile ? "mobile" : ""}`}>
                        <div className={`card-viewer-sort-wrapper ${isMobile ? "mobile" : ""}`}>
                            <select
                                value={sortingFilter.sort}
                                onChange={(e) => {
                                    setSortingFilter(prev => {
                                        return {
                                            ...prev,
                                            sort: e.target.value
                                        }
                                    })
                                }}
                            >
                                <option value="">По дате добавления</option>
                                <option value="date-reverse">По дате добавления с конца</option>
                                <option value="alphabet">По алфавиту</option>
                                <option value="alphabet-reverse">По алфавиту с конца</option>
                                <option value="bank">По банку</option>


                            </select>

                            <div className={"online-first-trader-filter-container"}>
                                <label htmlFor={"only-online-cards-trader"}>
                                    Сначала онлайн
                                </label>
                                <input
                                    checked={sortingFilter.onlineFirst}
                                    type={"checkbox"}
                                    id={"only-online-cards-trader"}
                                    onClick={() => {
                                        setSortingFilter(prev => ({
                                            ...prev,
                                            onlineFirst: !prev.onlineFirst

                                        }));
                                    }}
                                />

                            </div>

                        </div>
                        </div>
                        :
                        null
                    }


                    {store.user.roles.includes("support")
                        ?
                        <div className={`order-filter-wrapper ${isMobile ? "mobile" : ""}`}>
                            <div className={`card-viewer-sort-wrapper ${isMobile ? "mobile" : ""}`}>


                                {/*<select*/}
                                {/*    value={filter.traderId ?? ""}*/}
                                {/*    onChange={(e) => {*/}
                                {/*        const selectedTrader = traders.find(trader => trader.id === e.target.value);*/}

                                {/*        setCards([])*/}

                                {/*        setFilter(prev => {*/}

                                {/*            const newState = {*/}
                                {/*                ...prev,*/}
                                {/*                traderId: e.target.value,*/}
                                {/*                traderLogin: selectedTrader?.login || "",*/}
                                {/*            }*/}

                                {/*            if (e.target.value === "") {*/}
                                {/*                newState.onlyActive = true*/}
                                {/*                delete prev.trafficType*/}
                                {/*            }*/}


                                {/*            return newState*/}

                                {/*        })*/}


                                {/*        setTimeout(() => {*/}
                                {/*            // setStopFetching(false);*/}
                                {/*            // setFetching(true);*/}
                                {/*        }, 1000);*/}
                                {/*    }}*/}
                                {/*>*/}
                                {/*    <option value="">*/}
                                {/*        Все активные*/}
                                {/*    </option>*/}
                                {/*    {Object.values(traders)*/}
                                {/*        .sort((a, b) => a.login.localeCompare(b.login))*/}
                                {/*        .map(trader => (*/}
                                {/*            <option key={trader.id} value={trader.id}>*/}
                                {/*                {trader.login}*/}
                                {/*            </option>*/}
                                {/*        ))}*/}
                                {/*    /!*{traders.map(trader => (*!/*/}
                                {/*    /!*    <option key={trader.id} value={trader.id}>*!/*/}
                                {/*    /!*        {trader.login}*!/*/}
                                {/*    /!*    </option>*!/*/}
                                {/*    /!*))}*!/*/}
                                {/*</select>*/}

                                <Select
                                    options={[
                                        { value: '', label: 'Все активные', isDefault: true },
                                        ...traders
                                            .sort((a, b) => a.login.localeCompare(b.login))  // Сортировка по алфавиту
                                            .map(trader => ({
                                                value: trader.id,
                                                label: trader.login,
                                                data: trader
                                            }))
                                    ]}
                                    value={filter.traderId
                                        ? {
                                            value: filter.traderId,
                                            label: traders.find(t => t.id === filter.traderId)?.login || '...'
                                        }
                                        : { value: '', label: 'Все активные' }
                                    }
                                    onChange={(selected) => {
                                        const value = selected ? selected.value : '';
                                        const trader = selected?.data;

                                        setCards([]);
                                        setFilter(prev => ({
                                            ...prev,
                                            traderId: value,
                                            traderLogin: trader?.login || "",
                                            ...(value === "" && { onlyActive: true })
                                        }));
                                    }}
                                    isClearable={false}
                                    className="card-viewer-react-select-container"
                                    classNamePrefix="card-viewer-react-select"
                                />

                                <select
                                    onChange={(e) => {
                                        // setCards([])
                                        setFilter(prev => {

                                            const newState = {
                                                ...prev,
                                                trafficType: e.target.value,

                                            }
                                            return newState
                                        })
                                    }}
                                >
                                    <option value={""}>Все типы трафика</option>
                                    <option value={"card_number"}>По номеру карты (РФ)</option>
                                    <option value={"sbp"}>СБП (РФ)</option>
                                    <option value={"card_number_transgran"}>По номеру карты (ТГ)</option>
                                    <option value={"sbp_transgran"}>СБП (ТГ)</option>
                                    <option value={"nspk"}>НСПК</option>
                                </select>

                                {filter.traderId
                                    ?
                                    <div>
                                        <input
                                            checked={filter.onlyActive}
                                            type={"checkbox"}
                                            id={"only-online-cards"}
                                            onClick={() => {
                                                setFilter(prev => ({
                                                    ...prev,
                                                    onlyActive: !prev.onlyActive

                                                }));
                                            }}
                                        />
                                        <label htmlFor={"only-online-cards"}>
                                            Только в работе
                                        </label>
                                    </div>
                                    :
                                    <h3 className={"nowrap-h"}>{`Всего ${cards.length}`}</h3>
                                }


                                {/*<button*/}
                                {/*    className={"gradient-dark-button"}*/}
                                {/*    onClick={() => {*/}

                                {/*        setAppeals([])*/}
                                {/*        setProcessing(true)*/}
                                {/*        setSkipCounter(0);*/}

                                {/*        setFilter({status: "pending", onlyMine: store.user.id, startDate: "", stopDate: ""})*/}


                                {/*        setTimeout(() => {*/}
                                {/*            setStopFetching(false)*/}
                                {/*            setFetching(true)*/}
                                {/*        }, 1000)*/}
                                {/*    }}*/}
                                {/*>Сброс*/}
                                {/*</button>*/}


                            </div>
                        </div>
                        :
                        null
                    }


                    {isMobile
                        ?
                        <CardViewerTabs

                            store={store}
                            sortedCards={sortedCards}
                            setQrData={setQrData}
                            setQrName={setQrName}
                            setActiveModalQr={setActiveModal}
                            startCardTest={startCardTest}
                            processing={processing}
                            setCardToDelete={setCardToDelete}
                            setCardToUnbind={setCardToUnbind}
                            setActiveModalConfirm={setActiveModalConfirm}
                            setModalMessage={setModalMessage}
                            activateCardWithoutTest={activateCardWithoutTest}
                            changeCardStatus={changeCardStatus}
                        />
                        :
                        <CardViewerTable

                            store={store}
                            sortedCards={sortedCards}
                            setQrData={setQrData}
                            setQrName={setQrName}
                            setActiveModalQr={setActiveModal}
                            startCardTest={startCardTest}
                            processing={processing}
                            setCardToDelete={setCardToDelete}
                            setCardToUnbind={setCardToUnbind}
                            setActiveModalConfirm={setActiveModalConfirm}
                            setModalMessage={setModalMessage}
                            activateCardWithoutTest={activateCardWithoutTest}
                            changeCardStatus={changeCardStatus}
                        />
                    }



                    <ModalDialog
                        active={activeModal}
                        setActive={setActiveModal}
                        // action={() => {
                        //     setActiveModal("progress")
                        //     setTimeout(() => {
                        //         setActiveModal("no")
                        //     }, 100)
                        // }}
                        message={modalMessage}
                        purpose={"info"}
                        buttonText2={"OK"}
                    />
                    <ModalDialog
                        active={activeModalQr}
                        setActive={setActiveModalQr}
                        qrcode={qrData}
                        message={qrName}
                        purpose={"info"}
                    />

                    <ModalDialog
                        active={activeModalConfirm}
                        setActive={setActiveModalConfirm}
                        message={modalMessage}
                        purpose={"choice"}
                        action={
                            cardToDelete
                                ? () => deleteCard(cardToDelete)
                                : () => unbindCard(cardToUnbind)
                        }

                    />

                    <ModalDialog
                        active={activeModalInfo}
                        setActive={setActiveModalInfo}
                        message={modalMessage}
                        purpose={"info"}
                        buttonText2={"OK"}
                    />
                </div>
            );
        };

        export default CardViewer;